export interface ProjectSettingsSection {
  /** URL path segment, relative to `/:projectId/settings`. */
  value: string;
  /** i18n key shared by the side-nav item and the page title. */
  i18nKey: string;
  /** English fallback shown until translations load. */
  label: string;
}

// Single source of truth for the Project Settings side-nav items and their
// routes. The side-nav label and the page title intentionally share the same
// key, since they are always the same string.
export const PROJECT_SETTINGS_SECTIONS: ProjectSettingsSection[] = [
  {
    value: 'live-agent-platforms',
    i18nKey: 'pro-studio/navigation:project_settings.live_agent_platforms',
    label: 'Live Agent Platforms',
  },
  {
    value: 'reporting-api-credentials',
    i18nKey: 'pro-studio/navigation:project_settings.reporting_api_credentials',
    label: 'Reporting API Credentials',
  },
  {
    value: 'data-privacy',
    i18nKey: 'pro-studio/navigation:project_settings.data_privacy',
    label: 'Data Privacy',
  },
  {
    value: 'advanced-settings',
    i18nKey: 'pro-studio/navigation:project_settings.advanced_settings',
    label: 'Advanced Settings',
  },
];

// The section the index route redirects to.
export const DEFAULT_PROJECT_SETTINGS_SECTION = PROJECT_SETTINGS_SECTIONS[0];
